module.exports = "pegasus/assets/themelp1/small/13.png";